import * as React from "react"
import Flink from '~/components/shared/flink'
import { usePost } from '~/contexts/PostContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import { aria_btn } from "~/styles/app.module.scss"
import * as styles from "~/styles/blog/feature-box.module.scss"
import * as bstyle from "~/styles/blog/blog.module.scss"

const FeatureBox = ({ blockId, index }) => {
  const { post } = usePost()
  const block = post.data.blocks.find(x => x.id === blockId)
  const { settings } = block
  
  const boxes = settings.boxes.filter(x => notBlank(x.title))

  const handleClick = (targ) => {
    document.querySelector(`#${targ}`).scrollIntoView({
      behavior: 'smooth'
    })
  }

  return (
    <>
      <div className={styles.sfeats_menu}>
        <div className={styles.cont}>
          {boxes.map((box, index) => 
            <button
              type="button"
              key={`boxbtn${index}`}
              className={aria_btn}
              onClick={(e) => handleClick(`box${index}`)}
            >
              {box.title.toLowerCase()}
            </button>
          )}
        </div>
      </div>
      <div 
        className={jnstyls([styles.sfeats, bstyle.sec])}
        block={block.id}
      >
        {boxes.map((box, index) => 
          <div key={`box${index}`} id={`box${index}`} className={styles.box}>
            <div className={styles.top}>
              <div className={styles.title}>
                {box.title}
              </div>
              <div className={styles.cta}>
                <Flink
                  href={box.link} 
                  className={bstyle.cta_link}
                >
                  {box.cta}
                </Flink>
              </div>
            </div>
            <div className={styles.content}>
              <div className={styles.copy}>
                <p>{box.copy}</p>
              </div>
              <div className={styles.image}>
                <Flink 
                  href={box.link}
                >
                  <img 
                    src={imgSize(box.image,900)} 
                    alt={`${box.title} diagram of features`}
                    height={900} width={900}
                  />
                </Flink>
              </div>
            </div>
            <div className={styles.bottom}>
              <Flink 
                href={box.link} 
                className={bstyle.cta_link}
              >
                {box.cta}
              </Flink>
            </div>
          </div>
        )}

        {notBlank(settings.summary.title) && (
          <div className={styles.summary}>
            <div className={styles.title}>
              {settings.summary.title}
            </div>

            <div className={styles.box}>
              <div className={styles.content}>
                <div className={styles.image}>
                  <Flink 
                    href={settings.summary.link}
                  >
                    <img 
                      src={imgSize(settings.summary.image1,900)} 
                      alt={`${settings.summary.title} diagram of features`}
                      height={900} width={900}
                    />
                  </Flink>
                </div>
                <div className={styles.image}>
                  <Flink 
                    href={settings.summary.link}
                  >
                    <img 
                      src={imgSize(settings.summary.image2,900)} 
                      alt={`${settings.summary.title} detail`}
                      height={900} width={900}
                    />
                  </Flink>
                </div>
              </div>
              <div className={styles.top}>
                <div className={styles.copy}>
                  <p>{settings.summary.copy}</p>
                </div>
                <div className={styles.cta}>
                  <Flink 
                    href={settings.summary.link} 
                    className={bstyle.cta_link}
                  >
                    {settings.summary.cta}
                  </Flink>
                </div>
              </div>
              <div className={styles.bottom}>
                <Flink 
                  href={settings.summary.link} 
                  className={bstyle.cta_link}
                >
                  {settings.summary.cta}
                </Flink>
              </div>
            </div>

          </div>
        )}

      </div>
    </>
  )
}

export default FeatureBox


